export default __webpack_public_path__ + "static/media/enigma.cab69e71.png";